import React, { useEffect, useState } from "react";
import styled from "@emotion/styled";
import { Colors } from "./components/colors";
import Footer from "./components/footer.jsx";
import NavBar from "./components/navbar.jsx";
import NoticeBanner from "./components/noticeBanner.jsx";
import Banner from "./components/banner.jsx";
import Feat from "./components/featurebar.jsx";
import MainTable from "./components/maintable/maintable.jsx";
import SalaryAndCompanyCount from "./components/salaryandcompanycount.jsx";
import LogoWall from "./components/logowall.jsx";
import SalaryCalculator from "./components/calculator.jsx";
import { grid } from "ldrs";
import backgroundImage from "../static/images/white-noise.jpeg";
import { mobileWidth } from "./components/constants.jsx";
import FAQ from "./components/faq.jsx";
import { withTranslation } from "react-i18next";
import { useCompanies } from "./contexts/CompanyContext.jsx";

grid.register();

const Index = ({ i18n }) => {
  const [isMainTableLoading, setMainTableLoading] = useState(true);
  const { loading: companiesLoading } = useCompanies();

  useEffect(() => {
    if (!companiesLoading) {
      setMainTableLoading(false);
    }
  }, [companiesLoading]);

  // Safety net: never let the loading overlay block the page indefinitely
  // (e.g. if the companies request hangs). Reveal the page after 8s regardless.
  useEffect(() => {
    const timeout = setTimeout(() => setMainTableLoading(false), 8000);
    return () => clearTimeout(timeout);
  }, []);

  return (
    <div dir={i18n.dir()}>
      <BackgroundContainer>
        {isMainTableLoading && (
          <Overlay>
            <l-grid size="100" speed="1.5" color="black"></l-grid>{" "}
          </Overlay>
        )}
        <MainCol>
          <NavBar />
          <NoticeBanner />
          <Banner />
          <SalaryAndCompanyCount />
          <LogoWall />

          <FlexRow>
            <MainTable />
            {/* <SalaryCalculator /> */}
          </FlexRow>
          <Feat />
          <FAQ />
          <Footer />
        </MainCol>
      </BackgroundContainer>
    </div>
  );
};

export default withTranslation()(Index);

const BackgroundContainer = styled.div`
  background-repeat: repeat; /* Repeat the background image */
  background-size: 100% auto; /* Set the size of the repeated images */
  width: 100%;
  min-height: 100vh; /* Ensure the container takes at least the full viewport height */
  position: relative; /* Use relative positioning */
`;

const Overlay = styled.div`
  position: fixed; /* Position it fixed on the screen */
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000; /* High z-index to ensure it's above other content */
  background: ${Colors.white};
`;

const FlexCol = styled.div`
  display: flex;
  flex-direction: column;
`;

const MainCol = styled(FlexCol)`
  justify-content: space-between;
`;

const FlexRow = styled.div`
  display: flex;
  flex-direction: row;
  align-items: start;
  align-self: center;
  width: 80vw;
  margin: 20px;
  gap: 40px;
  justify-content: space-between;
  @media (max-width : ${mobileWidth}){
  flex-direction: column;
  }
`;
